export const DEFAULT_COLOR_PICKER = '#343a40'
export const FILTER_MAX_RESULT_VISIBLE = 25
export const FILTER_MIN_INPUT_LENGTH = 3
export const FILTER_MAX_SORTED_COLLAPSABLES = 6
export const PRIVACY_POLICY_URL = ''
export const MAX_FILE_SIZE = 25000000
export const MAX_DIPLAYED_FLAGGED_USERS_FOR_MULTISELECT = 20
